import { Stack } from '@mui/material';
import { FC } from 'react';
import { VyDivider } from '../../../../../../components/new-design/atoms';
import { OverdueListItem } from './OverdueListItem';

type OverdueStat = {
  name: string;
  priceValue: number;
  count: number;
  dataVy?: string;
};

type OverdueListProps = {
  overdueStats: OverdueStat[];
};

export const OverdueList: FC<OverdueListProps> = ({ overdueStats }) => {
  return (
    <Stack divider={<VyDivider />} sx={{
      gap: "17px"
    }}>
      {overdueStats.map((overdueStat) => (
        <OverdueListItem
          key={overdueStat.name}
          overdueStatName={overdueStat.name}
          priceValue={overdueStat.priceValue}
          count={overdueStat.count}
          dataVy={overdueStat.dataVy}
        />
      ))}
    </Stack>
  );
};
